import { ChecklistMetricStatus } from '../../handoff-checklist-v2/handoff-checklist-v2.types';
import { VoiceAirMetricDefinition } from '../voice-air-metrics.types';
import { getTruelarkBusinessIdQueryOptions } from '../voice-air-handoff.queries';
import { getParsedErrorMessage } from 'redux/axios';

export const truelarkBusinessIdMetric: VoiceAirMetricDefinition = {
  id: 'truelark_business_id',
  name: 'TrueLark Business ID',
  isRequired: true,
  criteria: [
    {
      description:
        'TrueLark Business ID is entered in WAM, linked to Weave for Fusion experience.',
      whereToFix: {
        label: 'WAM Sidenav > Location Info',
        url: (ctx) => `/locations/${ctx.locationId}/dashboard`,
      },
      evaluate: async (ctx) => {
        try {
          const resp = await ctx.queryClient.fetchQuery(
            getTruelarkBusinessIdQueryOptions(ctx.locationId, ctx.orgId)
          );

          let truelarkBusinessId = '';
          if (
            resp &&
            'setting' in resp &&
            resp.setting &&
            'truelarkLocationSetting' in resp.setting
          ) {
            truelarkBusinessId = resp.setting.truelarkLocationSetting?.businessId || '';
          }

          if (!truelarkBusinessId) {
            return {
              status: ChecklistMetricStatus.BLOCKED,
              reason: 'truelark_business_id_missing',
              message:
                'TrueLark Business ID is not set for this location in WAM Location configuration.',
            };
          }
          return {
            status: ChecklistMetricStatus.PASSED,
            reason: 'truelark_business_id_configured',
            message: 'TrueLark Business ID is configured.',
          };
        } catch (err) {
          return {
            status: ChecklistMetricStatus.BLOCKED,
            reason: 'api_request_failed',
            message:
              getParsedErrorMessage(err) ||
              'Failed to retrieve location details to verify TrueLark Business ID.',
          };
        }
      },
    },
  ],
};
